import SHARED from './constants.json';

export const KENKYU_SHUBETSU = SHARED.KENKYU_SHUBETSU;
export const KENKYU_MOKEI = SHARED.KENKYU_MOKEI;
export const Representative_Class = SHARED.Representative_Class;
export const SHOZOKU_LIST = SHARED.SHOZOKU_LIST;
export const CONTENT_OPTIONS = SHARED.CONTENT_OPTIONS;
export const WEEKDAYS = SHARED.WEEKDAYS;